import * as logger from 'ls-common-client/dist/logger';
import config from '../../src/client/config';

const instance = logger.create(config.logger || {});

export default instance;
